import React from "react";
import { useTranslation } from "react-i18next";
import { TextField, Grid, Paper, Box, LinearProgress } from "@mui/material";
import Button from "@/components/button";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams, useHistory } from "react-router-dom";

import images from "@/assets/images";
import banner from "@/assets/images/login/banner.png";
import useStyles from "./styles";

const ResetPasswordPage = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { code } = useParams();
  const history = useHistory();

  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required(t("login_screen.password_required"))
      .test(
        "uppercase-validation",
        t("login_screen.uppercase_required"),
        function (value) {
          return /[A-Z]/.test(value);
        }
      )
      .test(
        "lowercase-validation",
        t("login_screen.lowercase_required"),
        function (value) {
          return /[a-z]/.test(value);
        }
      )
      .test(
        "number-validation",
        t("login_screen.number_required"),
        function (value) {
          return /\d/.test(value);
        }
      )
      .test("length-validation", t("login_screen.min_chars"), function (value) {
        return value?.length >= 8;
      }),
    confirm_password: Yup.string().test(
      "passwords-match",
      t("login_screen.password_mismatch"),
      function (value) {
        return this.parent.password === value;
      }
    ),
  });

  const onResetPassword = (values) => {
    console.log(values);
  };

  return (
    <Grid container component={"main"} sx={{ height: "100vh" }}>
      <Grid
        item
        sm={4}
        md={7}
        sx={{
          display: { xs: "none", sm: "block" },
          backgroundImage: `url(${banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Box
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
          width={"80%"}
          height={"100%"}
          margin={"auto"}
        >
          <Box sx={{ marginTop: "15vh" }}>
            <img src={images.logo} width={150} height={60} />
          </Box>

          <Box marginTop={6} marginBottom={3}>
            <span className={classes.signInText}>
              {t("login_screen.reset_password")}
            </span>
          </Box>
          <Formik
            initialValues={{ password: "", confirm_password: "" }}
            validationSchema={validationSchema}
            onSubmit={onResetPassword}
          >
            {({
              handleBlur,
              handleSubmit,
              values,
              errors,
              touched,
              setFieldValue,
            }) => (
              <Box component="form" noValidate onSubmit={handleSubmit}>
                <TextField
                  margin="normal"
                  fullWidth
                  name="password"
                  label={t("login_screen.password")}
                  type="password"
                  value={values.password}
                  onChange={(e) => setFieldValue("password", e.target.value)}
                  onBlur={handleBlur}
                  error={touched.password && !!errors.password}
                  helperText={touched.password && errors.password}
                />
                <TextField
                  margin="normal"
                  fullWidth
                  name="confirm_password"
                  label={t("login_screen.confirm_password")}
                  type="password"
                  value={values.confirm_password}
                  onChange={(e) =>
                    setFieldValue("confirm_password", e.target.value)
                  }
                  onBlur={handleBlur}
                  error={touched.confirm_password && !!errors.confirm_password}
                  helperText={
                    touched.confirm_password && errors.confirm_password
                  }
                />
                <Button
                  color="primary"
                  type="submit"
                  fullWidth={true}
                  variant="contained"
                  sx={{ mt: 4, mb: 2 }}
                  className={classes.resetButton}
                >
                  {t("login_screen.reset_password")}
                </Button>
              </Box>
            )}
          </Formik>

          <Box
            flex={"auto"}
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"flex-end"}
            marginBottom={6}
            textAlign={"center"}
          >
            <span className={classes.contactText}>
              {t("login_screen.copyright", { year: new Date().getFullYear() })}
            </span>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ResetPasswordPage;
